import { formatUrlTrailing } from '@Utils/urlFormatting';
import {
	axiosWithHeaders,
	getService,
	Environments,
} from '@innovyze/lib_get_service';
import config from './config.api';

// See comments in package.md wrt eslint-disable-line below
const apiEnv =
	(localStorage.getItem('apiEnv') as keyof typeof Environments) || undefined; // eslint-disable-line

export const assetsBaseUrl = formatUrlTrailing(
	getService('assets', config, apiEnv),
);

const service = axiosWithHeaders({
	config,
	service: 'assets',
	axiosCreateOpts: {
		timeout: 15000,
	},
});

export default service;
